import React from 'react';
import PropTypes from 'prop-types';
// import { withRouter } from 'react-router';
import { scrollTo } from '../../utils/historyUtils';
import { withRouter } from 'next/router';

class HashLink extends React.Component {
    constructor(props) {
        super(props);

        this._onClick = this._onClick.bind(this);
    }

    _onClick(event) {
        const { onClick } = this.props;

        if (onClick) {
            onClick(event);
        }

        if (event.defaultPrevented) {
            return;
        }

        event.preventDefault();

        const hashId = this.getHash();

        if (hashId) {
            // router.push({
            //     ...location,
            //     ...{ hash: `#${hashId}` },
            //     ...{ state: { skipRouting: true } },
            // });

            // @todo : Routing xD

            scrollTo(hashId);

            //set focus on element
            const el = document.getElementById(hashId);
            if (el) {
                el.focus();
            }
        }
    }

    getHash() {
        const { hash } = this.props;

        return hash && typeof hash === 'string' ? hash.replace('#', '') : '';
    }

    render() {
        const {
            className,
            focused, // eslint-disable-line no-unused-vars
            router, // eslint-disable-line no-unused-vars
            hash, // eslint-disable-line no-unused-vars
            params, // eslint-disable-line no-unused-vars
            routes, // eslint-disable-line no-unused-vars
            children,
            query, // eslint-disable-line no-unused-vars
            match, // eslint-disable-line no-unused-vars
            replace, // eslint-disable-line no-unused-vars
            onClick, // eslint-disable-line no-unused-vars
            ...other
        } = this.props;

        return (
            <a
                href={`${router.asPath}#${this.getHash()}`}
                className={className}
                onClick={this._onClick}
                {...other}
            >
                {children}
            </a>
        );
    }
}

HashLink.propTypes = {
    hash: PropTypes.string.isRequired,
    className: PropTypes.string,
    onClick: PropTypes.func,
};

export default withRouter(HashLink);
